import { render, staticRenderFns } from "./PosterFromTimeline.vue?vue&type=template&id=24a8bd01&scoped=true&"
import script from "./PosterFromTimeline.vue?vue&type=script&lang=js&"
export * from "./PosterFromTimeline.vue?vue&type=script&lang=js&"
import style0 from "./PosterFromTimeline.vue?vue&type=style&index=0&id=24a8bd01&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a8bd01",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24a8bd01')) {
      api.createRecord('24a8bd01', component.options)
    } else {
      api.reload('24a8bd01', component.options)
    }
    module.hot.accept("./PosterFromTimeline.vue?vue&type=template&id=24a8bd01&scoped=true&", function () {
      api.rerender('24a8bd01', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/mix/PosterFromTimeline.vue"
export default component.exports